require('./catalog-search.component.scss');

class CatalogSearchController {
  constructor(
    CurrentFilterService,
    LayoutService,
    CatalogNodeDragService,
  ) {
    // this.drag = CatalogNodeDragService;
    this.layout = LayoutService;
    this.currentFilter = CurrentFilterService;
    // this.value = '';
    this.previousValue = '-';
    this.searchFilters();
  }

  searchKeyup(event) {
    if (event.keyCode === 13) {
      this.searchFilters();
    }
  }

  searchClean() {
    this.layout.searchTrim = '';
    this.searchFilters();
  }

  searchFilters() {
    if (this.layout.searchTrim === this.previousValue) return;
    this.previousValue = this.layout.searchTrim;
    if (this.layout.searchTrim) {
      this.layout.searchedFilters = this.currentFilter.FiltersService.searchFilters(f =>
        f.name.toLowerCase().indexOf(this.layout.searchTrim.toLowerCase()) !== -1 ||
        (f.emails && f.emails.toLowerCase().indexOf(this.layout.searchTrim.toLowerCase()) !== -1)
      );
    } else this.layout.searchedFilters = this.currentFilter.FiltersService.searchFilters();
  }
}


export const CatalogSearchComponent = {
  template: require('./catalog-search.component.html'),
  bindings: {},
  controller: CatalogSearchController,
};



// WEBPACK FOOTER //
// ./src/filter/catalog/catalog-search.component.js